import Button from '@components/formControls/Button'
import { Autocomplete } from '@mui/material'
import Badge from '@mui/material/Badge'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import TextField from '@mui/material/TextField'
import { Theme, styled } from '@mui/material/styles'
import { colors, componentSizes } from '@theme/variables'

export const SearchCountBadge = styled(Badge)(({ right, top }: { right?: string; top?: string }) => ({
  '& .MuiBadge-badge': {
    minHeight: '20px',
    minWidth: '20px',
    color: '#fff',
    borderRadius: '66px',
    padding: '2px 4px 2px 4px',
    fontSize: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: right ?? '-37px',
    top: top ?? '-22px',
  },
}))

export const SearchSectionWrapper = styled('div')`
  border: 1px solid ${colors.lightGrey};
  border-radius: 4px;
  padding: 20px;
  background-color: ${colors.white};
  display: flex;
  align-items: start;
  flex-direction: column;
`

export const SearchStartRowContainer = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-bottom: ${componentSizes.smDistance};
`

export const SearchInputWrapper = styled('div')`
  flex: 1 1 auto;
  width: 100%;
  display: flex;
  overflow: hidden;
  ${(props: { theme: Theme }) => props.theme.breakpoints.up('md')} {
    width: 60%;
    margin-right: ${componentSizes.smDistance};
    max-width: 585px;
  }
`
export const SearchInput = styled(TextField)`
  overflow: hidden;

  & .MuiOutlinedInput-root {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline,
  & .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: #6f6f6f;
  }
`
export const PlaceholderText = styled('span')`
  font-weight: 400;
  opacity: 0.6;
  & b {
    font-weight: 600;
  }
`

export const CancelSearchIconWrapper = styled('button')`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 10px;
  border: none;
  background: none;
  padding: 0;
`

export const SearchIconWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  background: #424242;
  border-radius: 0px 4px 4px 0px;
  font-size: 30px;
  cursor: pointer;
`

export const ProfileTypeFiltersContainer = styled('div')`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;

  ${(props: { theme: Theme }) => props.theme.breakpoints.down('md')} {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const ProfileTypeFilterItemWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${componentSizes.smDistance};

  ${(props: { theme: Theme }) => props.theme.breakpoints.down('md')} {
    margin-bottom: 2px;
  }
`

export const StyledFormControlLabel = styled(FormControlLabel)`
  margin: 0;
`

export const StyledCheckbox = styled(Checkbox)`
  padding: 0 0 0 4px;
`
export const SavedSearchBtn = styled(Button)<{ $saveSearchActive?: boolean }>`
  && {
    padding: 11px 13px;
  }

  &.Mui-disabled {
    padding: 10px 13px;
    background-color: transparent;
    border: 1px solid rgba(0, 0, 0, 0.23);
  }

  ${({ $saveSearchActive }) =>
    $saveSearchActive
      ? `
          min-width: '80px';
          max-width: '170px';
          background: #fff;
          color: ${colors.pink};
          border: '1px solid ${colors.primary}';
          font-weight: 700;
          &:hover {
            color: ${colors.pink};
          }
        `
      : ''}
`

export const StyledAutocomplete = styled(Autocomplete)`
  flex: 1;
  padding-right: 0;
  & .MuiInputBase-root {
    padding: 10px 0px 10px 10px;
  }
`

export const GroupItems = styled('ul')({
  padding: 0,
})
